interface Options {
	ratio?: {
		base?: {
			pc?: number
			pad?: number
			phone?: number
		}
	}
}

const ua = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : ''

export function setRatio(options: Options = {}) {
	const ua = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : ''
	const base = options?.ratio?.base ?? {}

	const baseSize = /iphone|android.*mobile|windows phone|ipod/i.test(ua) ? (base.phone ?? 375) : /ipad|android(?!.*mobile)|tablet/i.test(ua) ? (base.pad ?? 1100) : (base.pc ?? 1366)

	const updateFontSize = () => {
		if (typeof window !== 'undefined' && typeof document !== 'undefined') {
			const width = window.innerWidth || document.documentElement.clientWidth
			document.documentElement.style.fontSize = (width / baseSize) * 100 + 'px'
		}
	}

	updateFontSize()
	if (typeof window !== 'undefined') {
		window.addEventListener('resize', updateFontSize)
	}
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getMedia(options: Options = {}) {
	const isMobile = /iphone|android.*mobile|windows phone|ipod/i.test(ua)
	const isTablet = /ipad|android(?!.*mobile)|tablet/i.test(ua)

	return isMobile ? 'phone' : isTablet ? 'pad' : 'pc'
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function setMedia(options: Options = {}) {
	if (typeof document === 'undefined') {
		return
	}
	const html = document.documentElement
	const classList: string[] = []

	// 判断操作系统
	if (/windows/i.test(ua)) {
		classList.push('os-windows')
	} else if (/macintosh|mac os x/i.test(ua)) {
		classList.push('os-macos')
	} else if (/android/i.test(ua)) {
		classList.push('os-android')
	} else if (/iphone|ipad|ipod/i.test(ua)) {
		classList.push('os-ios')
	}

	// 判断设备类型
	const media = getMedia()
	if (media === 'pad') {
		classList.push('media-pad')
		classList.push('s_pad')
	} else if (media === 'phone') {
		classList.push('media-phone')
		classList.push('s_phone')
	} else {
		classList.push('media-pc')
		classList.push('s_pc')
	}

	// 添加 class 到 <html>
	html.className += ' ' + classList.join(' ')
}

export function getEm() {
	if (typeof document === 'undefined') {
		return 16 // 默认字体大小
	}
	const el = document.createElement('div')
	el.style.width = '1em'
	el.style.height = '1em'
	el.style.position = 'absolute'
	document.body.appendChild(el)
	const size = el.getBoundingClientRect().height
	document.body.removeChild(el)
	return size
}

export function commitTouchReport(detail) {
	if (typeof window.CustomEvent === 'function') {
		// IE11 下不支持 new CustomEvent 方法
		const TouchReport = new CustomEvent('touchreport', {
			detail: detail
		})
		document.dispatchEvent(TouchReport)
	}
}
